import { Alert, Classes, Dialog, FormGroup } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import {
  BootstrapTable,
  SearchField,
  TableHeaderColumn,
} from "react-bootstrap-table";
import ReactJson from "react-json-view";
import { ICnae, newICnae } from "../../model";
import { CnaeStore } from "../../stores/legislacao/CnaeStore";
import { AppStore } from "../../stores/AppStore";
import { toast } from "react-toastify";
import LoadingModal from "../loading/LoadingModal";

interface CnaePageProps {
}

interface CnaePageState {
}

@observer
export class CnaePage extends React.Component<CnaePageProps, CnaePageState> {
  obs = observable({
    cnaes: [] as ICnae[],
    viewing: newICnae() as ICnae,
    page: 1 as number,
    cnae: "" as string,
    atividade: "Selecione" as string,
    updateCnae: [] as string[]
  });

  constructor(props) {
    super(props);
    this.state = { handlePageChange: props.handlePageChange };
  }

  async componentDidMount() {
    AppStore.setTitle("CNAE");
    await CnaeStore.cnaeLoad(1);
    this.obs.cnaes = CnaeStore.obs.cnae;
  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (CNAE, Atividade, Descrição)"
      />
    );
  };



  handleAtualizarAtividade = async () => {
    if (this.obs.atividade == "Selecione") {
      toast.warning('Selecione pelo menos uma Atividade.', {});
    } else {
      if (this.obs.updateCnae.length) {
        let data = { atividade: this.obs.atividade, id: this.obs.updateCnae };
        await CnaeStore.updateAtividade(data);
        if (CnaeStore.obs.status200) {
          toast.success('Atividade Atualizada.', {});
          for (let i = 0; i < this.obs.cnaes.length; i++) {
            for (let j = 0; j < this.obs.updateCnae.length; j++) {
              if (this.obs.cnaes[i]._id == this.obs.updateCnae[j]) {
                this.obs.cnaes[i].atividade = this.obs.atividade;
              }
            }
          }
          let ref = [...this.obs.cnaes];
          this.obs.cnaes = [];
          this.obs.cnaes = [...ref];
        } else {
          toast.error('Erro ao atualizar atividade', {});
        }
      } else {
        toast.warning('Selecione um item', {});
      }
    }
  };

  handleRowSelect = async (row, checked) => {
    if (checked) {
      this.obs.updateCnae.push(row._id);
    } else {
      let index = this.obs.updateCnae.indexOf(row._id);
      this.obs.updateCnae.splice(index, 1);
    }
  };

  renderShowsTotal(start, to, total) {
    return (
      <p style={{ marginLeft: 12 }}>
        Mostrando {start} a {to} de {total} resultados.&nbsp;&nbsp;
      </p>
    );
  }

  render() {
    const handleViewResposta = (resp: ICnae) => {
      this.obs.viewing = resp;
      CnaeStore.obs.viewResposta = true;
    };

    function buttonFormatterResposta(cell, row) {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={(e) => handleViewResposta(row)}
          >
            <img src="/images/view.png" width="18px" />
          </MDBBtn>
        </>
      );
    }
    const renderSelectCheckbox = (check, row) => {
      if (check) {
        this.obs.updateCnae = row?.map(value => {
          return value._id;
        });
      } else {
        this.obs.updateCnae = [];
      }
    };

    const selectRowProp = {
      mode: "checkbox",
      clickToSelect: false,
      columnWidth: "40px",
      onSelect: this.handleRowSelect,
      onSelectAll: renderSelectCheckbox,
      isSelected: true,
      bgColor: "rgba(27, 98, 111, 0.1)",
    };

    const options = {
      page: 1,
      sizePerPageList: [{
        text: "15",
        value: 15,
      }, {
        text: "50",
        value: 50,
      }, {
        text: "100",
        value: 100,
      }],
      sizePerPage: 15,
      pageStartIndex: 1,
      paginationSize: 4,
      prePage: "Ante",
      nextPage: "Próxima",
      firstPage: "Início",
      lastPage: "Última",
      paginationShowsTotal: this.renderShowsTotal,
      paginationPosition: "bottom",
      searchField: this.createCustomSearchField,
    };

    let user_admin = AppStore.obs1.usuario ? AppStore.obs1.usuario.admin : false

    return (
      <>

        {user_admin &&
          <MDBRow xl="4" lg="4" md="4" sm="4">
            <MDBCol xl="4" lg="4" md="4" sm="4" xs="4">
              <FormGroup
                label="Alterar Atividade"
                className="nz-horizontal-field selectFullWidth"
              >
                <select
                  className="bp3-button bp3-align-left"
                  onChange={(e) => this.obs.atividade = e.target.value}
                >
                  <option key="Selecione">Selecione</option>
                  <option key="atacadista">atacadista</option>
                  <option key="industria">industria</option>
                  <option key="distribuidor">distribuidor</option>
                  <option key="varejista">varejista</option>
                  <option key="servicos">servicos</option>
                </select>
              </FormGroup>
            </MDBCol>

            <MDBCol md="2">
              <MDBBtn
                className="btnDefault btnBuscarNfe mt25"
                onClick={this.handleAtualizarAtividade}
              >
                Alterar
              </MDBBtn>
            </MDBCol>
          </MDBRow>
        }

        <div data-tut="table">
          <BootstrapTable
            className="TableDefault"
            ref="table"
            data={this.obs.cnaes}
            selectRow={user_admin ? selectRowProp : false}
            options={options}
            hover
            search
            pagination
          >
            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">
              #
            </TableHeaderColumn>
            <TableHeaderColumn dataField="cnae" dataSort={true} width="15%">
              CNAE
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="atividade"
              dataSort={true}
              width="15%"
            >
              Atividade
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="descricao"
              dataSort={true}
              width="50%"
            >
              Descrição
            </TableHeaderColumn>
            <TableHeaderColumn dataFormat={buttonFormatterResposta} width="15%">
              Detalhes
            </TableHeaderColumn>
          </BootstrapTable>
        </div>
        <div style={{ marginBottom: 80 }} />

        <Alert
          confirmButtonText="Fechar"
          isOpen={CnaeStore.obs.viewResposta}
          onClose={() => CnaeStore.obs.viewResposta = false}
          canOutsideClickCancel={true}
          className="AlertResposta"
        >
          <h2 className="titleSEFAZ">Detalhes</h2>

          <div className="heightResposta">
            <ReactJson
              collapsed={true}
              displayDataTypes={false}
              src={this.obs.viewing}
            />
          </div>
        </Alert>

        <LoadingModal open={CnaeStore.obs.loading} onClose={() => CnaeStore.obs.loading = false} title={"Carregando itens"} />

      </>
    );
  }
}
